import React from 'react';
import IconEmptyResults from '../../../config/static/svg/empy-results.svg';
import SvgIcon from '../svg-icon.component';
import styles from './style.module.scss';

type EmptyResultsProps = {
  image?: SVGAElement;
  imageName?: string;
  widthImage?: number;
  heightImage?: number;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
};

const EmptyResults: React.FC<EmptyResultsProps> = ({
  image,
  imageName,
  heightImage = 300,
  widthImage = 300,
  action,
  subtitle,
  title = '',
}) => {
  return (
    <div className={styles['empty-results-container']}>
      <div className={styles['icon']}>
        <SvgIcon source={image || IconEmptyResults} name={imageName} height={heightImage} width={widthImage} />
      </div>
      <div className={styles['title']}>
        <p>{title}</p>
      </div>
      {subtitle && (
        <div className={styles['subtitle']}>
          <p>{subtitle}</p>
        </div>
      )}
      {action && <div className={styles['action']}>{action}</div>}
    </div>
  );
};

export default EmptyResults;
